import { ActionReducerMap } from '@ngrx/store';
// import { OrderDetailsReducer } from './fetch-order-details.reducer';
import { deleteEntryOrderDetailsReducer } from './delete-order-entry.reducer';
import { deleteWholeOrderDetailsReducer } from './delete-whole-order.reducer';
import { RecreateReducer } from './recreate-cart.reducer';

interface CustomOrderState {
  entryDetailsCancel: ReturnType<typeof deleteEntryOrderDetailsReducer>;
  wholeOrderCancel: ReturnType<typeof deleteWholeOrderDetailsReducer>;
  recreateCancel: ReturnType<typeof RecreateReducer>;
  // orderFetchDetails?: ReturnType<typeof OrderDetailsReducer>;
}
 
export const customReducers: ActionReducerMap<CustomOrderState> = {
    // orderFetchDetails: OrderDetailsReducer,
    entryDetailsCancel:deleteEntryOrderDetailsReducer,
    wholeOrderCancel:deleteWholeOrderDetailsReducer,
    recreateCancel:RecreateReducer
};